var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mb-3"},[_c('h5',[_c('i',{staticClass:"el-icon-info text-primary mr-2"}),_c('i',[_vm._v(_vm._s(_vm.element.extraServiceDescription))])])]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.element.note.replace(/\n/g, '<br>\n'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }